import Form from 'src/utils/Form'
import { Cookies } from 'quasar'

// Change secure to 'true' for deploying
const secure = process.env.SECURE_COOKIE

const state = {
  token: Cookies.get('system_token') || null,
  waitForAuthorize: false,
};

const mutations = {
  'SET_TOKEN'(state, token) {
    state.token = token
  },
};

const actions = {
  login: ({commit}, credentials) => {
    let LoginObj = new Form({
      email: credentials.username,
      password: credentials.password,
      recaptcha: credentials.recaptcha,
      remember_me: credentials.remember_me
    });
    return new Promise((resolve, reject) => {
      LoginObj.post('login').then(({access_token}) => {
        commit('SET_TOKEN', access_token)
        Cookies.set('system_token', access_token, {
          secure: secure,
          path: '/'
        })
        resolve(access_token)
      }).catch((error) => {
        commit('SET_TOKEN', null)
        Cookies.remove('system_token')
        reject(error)
      })
    })
  },

  register: ({commit}, userObj) => {
      return new Promise((resolve, reject) => {
          userObj.post('register').then(({access_token}) => {
              commit('SET_TOKEN', access_token)
              Cookies.set('system_token', access_token, {
                  secure: secure,
                  path: '/'
              })
              resolve(access_token)
          }).catch((error) => {
              commit('SET_TOKEN', null)
              Cookies.remove('system_token')
              reject(error)
          })
      })
  },

  async logout({commit}) {
    try {
      await new Form().post('logout');
      Cookies.remove('system_token')
      Cookies.remove('user')
      commit('SET_TOKEN', null)
      commit('REFRESH_USER')
      window.Echo.disconnect()
      return null
    } catch (e) {
      return e
    }
  },

  async refresh_token({commit}) {
    try {
      let response = await new Form().post('login/refresh');
      commit('SET_TOKEN', response.access_token)
      return response.access_token
    } catch (e) {
      commit('SET_TOKEN', null)
      return null
    }
  },

  forgot: ({commit}, credentials) => {
    let forgotObj = new Form({
      email: credentials.email,
      mobile: credentials.mobile,
      recaptcha: credentials.recaptcha
    });
    return new Promise((resolve, reject) => {
      forgotObj.post('forgot').then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  verify({commit}, credentials) {
    let verifyObj = new Form({
      email: credentials.email,
      activation_code: credentials.activation_code
    });
    return new Promise((resolve, reject) => {
      verifyObj.post('verify').then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  set_password({commit}, credentials) {
    let ChangePassObj = new Form({
      mobile: credentials.mobile,
      email: credentials.email,
      activation_code: credentials.activation_code,
      password: credentials.password,
      password_confirmation: credentials.password_confirmation,
    });
    return new Promise((resolve, reject) => {
      ChangePassObj.post('set/password').then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  confirm_email({commit}, data) {
    let CMObj = new Form({
      email: data.email,
      activation_code: data.activation_code,
    });
    return new Promise((resolve, reject) => {
      CMObj.post('confirm').then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
};

const getters = {
  access_token: state => state.token,
  isLoggedIn: state => !!state.token,
  waitForAuthorize: state => state.waitForAuthorize,
};

export default {
  state,
  mutations,
  actions,
  getters
};
